import { type AppNode } from '../../types';
import { buildImageNodes } from './buildImageNodes';
import { buildVideoNodes } from './buildVideoNodes';
import { type CanvasAssetPayload, type ImageNodesLayout, type VideoRejectionReason } from './canvasAssetDropTypes';
import { filterImageAssets } from './filterImageAssets';
import { payloadToImageNodeSources } from './payloadToImageNodeSources';

export type BuildNodesFromPayloadsResult = {
  nodes: AppNode[];
  addedCount: number;
  unsupportedCount: number;
  videoRejections: VideoRejectionReason[];
};

/**
 * Converts raw asset payloads into positioned canvas nodes (images + videos).
 * Combines the filter → source-normalize → build pipeline into a single call.
 */
export function buildNodesFromPayloads(
  payloads: CanvasAssetPayload[],
  layout: ImageNodesLayout,
): BuildNodesFromPayloadsResult {
  const { imageAssets, videoAssets, addedCount, unsupportedCount, videoRejections } = filterImageAssets(payloads);
  const sources = payloadToImageNodeSources(imageAssets);
  const { nodes: imageNodes, nextOffsetX } = buildImageNodes(sources, layout);
  const { nodes: videoNodes } = buildVideoNodes(videoAssets, layout, nextOffsetX);

  return { addedCount, nodes: [...imageNodes, ...videoNodes], unsupportedCount, videoRejections };
}
